import { computed, reactive } from 'vue';
import moment from 'moment';
import { BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';
import { BRANCH_LIMIT } from '../constants/constants';

const model = reactive({
	callbackReason: null,
	transferChannel: null,
	transferType: null,
	name: null,
	remitter: null,
	accountNumber: null,
	ownership: null,
	amount: null,
	currency: 'HUF',
	date: moment().format(BACKEND_DATE_FORMAT),
	beneficiaryAccountNumber: null,
	secondaryAccount: null,
	secondaryAccountId: null,
	transactionId: null,
	beneficiaryName: null,
	message: null,
	settlement: null,
	captchaKey: null,
	captchaText: null
});
export const useForm = () => {
	const isMisuse = computed(() => model.callbackReason === 'MISUSE');
	const isAmountOverBoundary = computed(() => model.amount > BRANCH_LIMIT && model.currency === 'HUF');
	const isTenA = computed(() => model.transferChannel === 'PHONE' || model.transferChannel === 'BANK' || isAmountOverBoundary.value);
	const isTenB = computed(() => model.transferChannel === 'ELECTRONIC' && !isAmountOverBoundary.value);
	const isSecondaryAccount = computed(() => isTenB.value && model.secondaryAccount);
	return { isMisuse, isTenA, isTenB, isSecondaryAccount, model };
};
